export const hanbookPlaceList = {
    id: 'hanbookPlaceList',
    api: 'defBridge',
    title: 'Основные Расходы',
    items: [
        { val: 'noShow', title: 'Не отображать' },
        { val: 'deal.Main', title: 'Сделка, основное' },
    ]
}